<h2 mat-dialog-title class="dialog-header">
  <div class="dialog-header-copy">
    <span>Sender Email</span>
    <p>Detalle del correo generado, su vista previa y los metadatos de envío.</p>
  </div>
  <button mat-icon-button aria-label="Close" (click)="activeModal.close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content">
  <section class="sender-summary-card">
    <div class="sender-summary-grid">
      <div class="summary-item">
        <span class="summary-label">ID</span>
        <strong>#{{ sender.id }}</strong>
      </div>
      <div class="summary-item">
        <span class="summary-label">Estado</span>
        <span class="status-pill" [class.status-pill--sent]="sender.sent" [class.status-pill--pending]="!sender.sent">
          {{ sender.sent ? 'Enviado' : 'Pendiente' }}
        </span>
      </div>
      <div class="summary-item">
        <span class="summary-label">Intentos</span>
        <strong>{{ sender.attempts || 0 }}</strong>
      </div>
      <div class="summary-item">
        <span class="summary-label">Template</span>
        <strong>{{ sender.template || 'Sin template' }}</strong>
      </div>
    </div>
  </section>

  <div class="read-grid two-columns sender-form-grid">
    <div class="read-item">
      <span class="read-label">From</span>
      <div class="read-value">{{ sender.from || '—' }}</div>
    </div>

    <div class="read-item">
      <span class="read-label">To</span>
      <div class="read-value">{{ sender.to || '—' }}</div>
    </div>

    <div class="read-item full-span">
      <span class="read-label">Subject</span>
      <div class="read-value">{{ sender.subject || '—' }}</div>
    </div>
  </div>

  <section class="preview-card">
    <div class="section-heading">
      <h3>Vista previa del email</h3>
      <p>Así se renderiza el HTML enviado al destinatario.</p>
    </div>
    <div class="preview-shell">
      <iframe class="preview-frame" [srcdoc]="sender.htmlBody"></iframe>
    </div>
  </section>

  <div class="read-grid two-columns sender-form-grid">
    <div class="read-item full-span">
      <span class="read-label">Plain Body</span>
      <pre class="read-block">{{ sender.plainBody || '—' }}</pre>
    </div>

    <div class="read-item full-span">
      <span class="read-label">Data</span>
      <pre class="read-block">{{ sender.data || '—' }}</pre>
    </div>

    <div class="read-item">
      <span class="read-label">Delivery Time</span>
      <div class="read-value">{{ sender.deliveryTime ? (sender.deliveryTime | date: appService.FORMAT_DATETIME) : '—' }}</div>
    </div>

    <div class="read-item">
      <span class="read-label">Created At</span>
      <div class="read-value">{{ sender.createdAt ? (sender.createdAt | date: appService.FORMAT_DATETIME) : '—' }}</div>
    </div>

    <div class="read-item full-span">
      <span class="read-label">Updated At</span>
      <div class="read-value">{{ sender.updatedAt ? (sender.updatedAt | date: appService.FORMAT_DATETIME) : '—' }}</div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <div class="dialog-actions-wrap">
    <button mat-raised-button color="primary" (click)="openTicket()">Mostrar Email</button>
  </div>
</mat-dialog-actions>
